module.exports = __webpack_public_path__ + "media/images/award-badges-en-a8644de1a4ce6b913e25979c36091c4f.svg";